/* =========================================================================
   Madesa Newsletter — captação de lead → HubSpot Forms Submission API v3
   -------------------------------------------------------------------------
   Portal: 39596724 | Região: na1
   Form:   8539a82d-9604-43a8-aebb-a2432cfe7301

   Campos enviados (internal names confirmados na HubSpot):
     firstname                        <- input "Nome Completo"
     email                            <- input "E-mail"
     madesa_email_consent             <- "true" (checkbox LGPD é obrigatório)
     nacionalidade                    <- setting do tema (por loja LATAM)
     origem_de_cadastro_staging       <- setting do tema
     origem_de_cadastro__crm__staging <- setting do tema

   IMPORTANTE: os três últimos vêm do painel do editor de tema da Shopify
   (seção "Madesa Newsletter"). Os valores digitados lá precisam bater
   caractere por caractere com uma opção da propriedade na HubSpot, senão
   o campo é descartado em silêncio (POST 200, propriedade vazia).

   Valores válidos hoje:
     nacionalidade: Brasil | México | Argentina | Colombia
     origem_de_cadastro_staging / __crm__staging: ex. "newsletter_home"

   O formulário nativo da Shopify ({% form 'customer' %}) recarrega a página
   no submit. Por isso o POST usa `keepalive: true` — a requisição sobrevive
   à navegação, do mesmo jeito que o antigo sendBeacon fazia.
   ========================================================================= */

document.addEventListener('DOMContentLoaded', function () {
  var HS_DEBUG = false; // ligue para logar o payload no console

  function getHutk() {
    var m = document.cookie.match(/(^|;\s*)hubspotutk=([^;]*)/);
    return m ? m[2] : '';
  }

  function postToHubspot(portalId, formId, fields) {
    var ctx = { pageUri: window.location.href, pageName: document.title };
    var hutk = getHutk();
    if (hutk) ctx.hutk = hutk; // NUNCA enviar hutk vazio — a API rejeita

    var payload = { fields: fields, context: ctx };

    if (HS_DEBUG) console.log('[newsletter] payload HubSpot', payload);

    return fetch(
      'https://api.hsforms.com/submissions/v3/integration/submit/' +
        portalId +
        '/' +
        formId,
      {
        method: 'POST',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      }
    )
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            if (!res.ok) {
              console.error('[newsletter] Falha no envio HubSpot', res.status, data);
            } else if (HS_DEBUG) {
              console.log('[newsletter] HubSpot OK', data);
            }
            return data;
          });
      })
      .catch(function (err) {
        console.error('[newsletter] Erro de rede no envio HubSpot', err);
      });
  }

  function buildFields(root, formEl) {
    var fieldsMap = new Map();
    var push = function (name, value) {
      if (name && value !== '' && value != null) {
        fieldsMap.set(name, String(value).trim());
      }
    };

    var nameEl = formEl.querySelector('[name="contact[first_name]"]');
    var emailEl = formEl.querySelector('[name="contact[email]"]');

    push('firstname', nameEl ? nameEl.value : '');
    push('email', emailEl ? emailEl.value : '');
    push('madesa_email_consent', 'true');

    push('nacionalidade', root.getAttribute('data-hs-nacionalidade') || '');
    push(
      'origem_de_cadastro_staging',
      root.getAttribute('data-hs-origem-staging') || ''
    );
    push(
      'origem_de_cadastro__crm__staging',
      root.getAttribute('data-hs-origem-crm-staging') || ''
    );

    return Array.from(fieldsMap, function (entry) {
      return { name: entry[0], value: entry[1] };
    });
  }

  // ---------------------------------------------------------------------
  // Envio para a HubSpot no submit do formulário nativo da Shopify
  // ---------------------------------------------------------------------
  var roots = document.querySelectorAll('[data-madesa-newsletter]');

  roots.forEach(function (root) {
    var formEl = root.querySelector('.capture-banner__form');
    if (!formEl) return;

    var portalId = root.getAttribute('data-hs-portal-id');
    var formId = root.getAttribute('data-hs-form-id');
    if (!portalId || !formId) {
      console.warn('[newsletter] portalId/formId ausentes — envio HubSpot desativado.');
      return;
    }

    // O Liquid decide qual formulário renderizar conforme o toggle
    // "Salvar o lead na Shopify":
    //   toggle LIGADO    -> form 'customer' nativo (sem data-newsletter-standalone)
    //   toggle DESLIGADO -> <form> comum com data-newsletter-standalone
    // Não tentamos cancelar o form da Shopify por JS: em temas Horizon existe um
    // handler AJAX próprio no form 'customer' que dispara antes do nosso
    // listener, e o preventDefault não desfaz a requisição já enviada.
    var standalone = formEl.hasAttribute('data-newsletter-standalone');

    var sent = false;

    formEl.addEventListener('submit', function (event) {
      if (sent) {
        if (standalone) event.preventDefault();
        return;
      }

      var emailEl = formEl.querySelector('[name="contact[email]"]');
      if (!emailEl || !emailEl.value) {
        if (standalone) event.preventDefault();
        return; // sem e-mail não há lead
      }

      sent = true; // otimista: evita disparo duplo

      if (!standalone) {
        // Fire-and-forget: o keepalive faz a requisição sobreviver ao reload
        // provocado pelo submit nativo da Shopify.
        try {
          postToHubspot(portalId, formId, buildFields(root, formEl));
        } catch (err) {
          console.error('[newsletter] Erro inesperado na captação.', err);
        }
        return;
      }

      // --- Captação na Shopify desligada: só HubSpot ---
      // Este <form> não tem action nem os campos ocultos da Shopify, então nada
      // aqui chega à loja. O preventDefault serve só para evitar o reload.
      event.preventDefault();

      var submitBtn = formEl.querySelector('.capture-banner__button');
      if (submitBtn) submitBtn.disabled = true;

      var finish = function () {
        showInlineSuccess(root);
      };

      try {
        postToHubspot(portalId, formId, buildFields(root, formEl)).then(finish, finish);
      } catch (err) {
        console.error('[newsletter] Erro inesperado na captação.', err);
        finish();
      }
    });
  });

  // Revela o card de cupom já presente no DOM e esconde os campos.
  // Usado apenas quando não há submit nativo (toggle da Shopify desligado).
  function showInlineSuccess(root) {
    root.querySelectorAll('[data-newsletter-fields]').forEach(function (el) {
      el.hidden = true;
    });

    var card = root.querySelector('[data-newsletter-success-inline]');
    if (!card) return;

    card.hidden = false;
    try {
      card.focus();
    } catch (e) {
      /* focus é conveniência, não requisito */
    }
  }

  // ---------------------------------------------------------------------
  // Copiar cupom (comportamento original preservado)
  // ---------------------------------------------------------------------
  var copyButtons = document.querySelectorAll('.success-message__copy-btn');

  copyButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();

      var textToCopy = this.getAttribute('data-copy-text');

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(textToCopy)
          .then(function () {
            showCopyFeedback(button);
          })
          .catch(function () {
            fallbackCopy(textToCopy, button);
          });
      } else {
        fallbackCopy(textToCopy, button);
      }
    });
  });

  function showCopyFeedback(button) {
    var originalSvg = button.innerHTML;

    button.innerHTML =
      '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M13.4142 20.5858L8 15.1716L6.58579 16.5858L13.4142 23.4142L27.4142 9.41421L26 8L13.4142 20.5858Z" fill="#28A745"/>' +
      '</svg>';

    button.style.opacity = '0.8';

    setTimeout(function () {
      button.innerHTML = originalSvg;
      button.style.opacity = '1';
    }, 2000);
  }

  function fallbackCopy(text, button) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      showCopyFeedback(button);
    } catch (err) {
      console.error('Erro ao copiar:', err);
    }

    document.body.removeChild(textarea);
  }
});